import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ContentWithPaddingXl, Container } from "components/misc/Layouts.js";
import { SectionHeading as Heading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-8.svg";


import LB from './../../images/LB.jpg';
import MB from './../../images/MB.jpg';
import SW from './../../images/SW.jpg';


const Subheading = tw(SubheadingBase)`text-center`;
const Testimonials = tw.div`flex flex-col lg:flex-row items-center lg:items-stretch`;
const TestimonialContainer = tw.div`mt-16 lg:w-1/3`;
const Testimonial = tw.div`px-4 text-center max-w-xs mx-auto flex flex-col items-center`;
const Image = tw.img`w-20 h-20 rounded-full`;
const Quote = tw.blockquote`mt-5 text-gray-600 font-medium leading-loose`;
const CustomerName = tw.p`mt-5 text-gray-900 font-semibold uppercase text-sm tracking-wide`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute left-0 top-0 h-56 w-56 opacity-15 transform -translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute right-0 bottom-0 h-64 w-64 opacity-15 transform translate-x-2/3 text-yellow-500`}
`;



export default ({
  subheading = "Testimonials",
  heading = "Customer's Review",
  testimonials = [
    {
      imageSrc:
        LB,
      quote:
        "Its (SmartView MD) simple, its straight to the point, and its very intuitive to use. SmartView MD literally redefines hyper-tension care. Real-time blood pressure data at your fingertips. This app turns every single cellphone into a life-line for patients. With remote patient monitoring you're not just tracking heath, you're transforming lives.",
      customerName: "Leon Bain, Jessie Trice Community Health system"
    },
    {
      imageSrc:
        SW,
      quote:
        "As a Community Health Worker (CHW/Health Coach), I have found its (SmartView MD) ease of use to be a true godsend. For the past 11 months, I’ve been working with the app designed specifically for the BP device we provide to clients. With the introduction of the SmartView app, the simplicity, clarity, and real-time visibility for both the client and the health coach are tremendous assets.",
      customerName: "Shari Williams, Florida Center for Change"
    },
    {
      imageSrc:
        MB,
      quote:
        "CFC Powered by SharpRPM is such a great app! Incredibly user-friendly, it helps clients who may have issues syncing data to their phone. The idea of this app is to make it easier for the clients and that it is much more user-friendly than other apps that may cause issues with syncing and losing the Bluetooth signal.",
      customerName: "Michelle Blackwell, Florida Center for Change"
    }
    
  ]
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        <Testimonials>
          {testimonials.map((testimonial, index) => (
            <TestimonialContainer key={index}>
              <Testimonial>
                <Image src={testimonial.imageSrc} />
                <Quote>"{testimonial.quote}"</Quote>
                <CustomerName>- {testimonial.customerName}</CustomerName>
              </Testimonial>
            </TestimonialContainer>
          ))}
        </Testimonials>
      </ContentWithPaddingXl>

      
    </Container>
  );
};
